import { useState } from "react";

// Global in-memory cache (stale-while-revalidate). Survives route navigation
// because it lives at module scope, so returning to a page shows the last
// loaded data instantly while a background fetch refreshes it.
const store = new Map();

export function useCached(key, initial) {
  const [val, setVal] = useState(() => (store.has(key) ? store.get(key) : initial));
  const set = (v) => {
    const prev = store.has(key) ? store.get(key) : initial;
    const next = typeof v === "function" ? v(prev) : v;
    store.set(key, next);
    setVal(next);
  };
  return [val, set];
}

// Clear cache (e.g. on login/logout so a different user never sees stale data).
export function clearDataCache(key) {
  if (key) store.delete(key);
  else store.clear();
}
